import React from 'react';
import Header from '../components/Header';
import Faqs from '../components/Faqs';
import Footer from '../components/Footer';

const FaqPage = () => {
    return (
        <main>
            <section className='cbp_layout_header'>
                <div className='container-fluid grey-border-b-1'>
                    <Header />
                </div>
            </section>
            <section className='section_padding cbp_layout_member'>
                <div className='container-fluid'>
                    <Faqs />
                </div>
            </section>
            <section className='cbp_layout footer-section'>
                <div className='container'>
                    <Footer />
                </div>
            </section>
        </main>
    );
};

export default FaqPage;
